import { useEffect, useState } from 'react';

const TOOLTIP_CLASS = 'game_tooltip';
export const MULTITOOLTIP_CLASS = 'multitooltip';
const CLOSE_BUTTON = 'close_button';

export default function useGlobalBodyClick(callback: (target: Element) => void) {
    useEffect(() => {
        const handleBodyClick = (e: MouseEvent) => {

            const isCloseTooltipButton = e.target && (e.target as Element).classList.contains(CLOSE_BUTTON);

            if (isCloseTooltipButton) {
                // ignore clicks to close tooltip button
                return;
            }

            const targetContainer = (e.target as Element).closest(`.${TOOLTIP_CLASS}`);

            if (targetContainer) {
                // ignore clicks to TOOLTIP_CLASS
                return;
            }

            callback(e.target as Element);
        };

        document.body.addEventListener('click', handleBodyClick);

        return () => {
            document.body.removeEventListener('click', handleBodyClick);
        };
    }, [callback]);
}